import SinglePostLayout from '@/layouts/SinglePostLayout';
import { markdownToHtml } from '@/utils/markdown';
import { PostProvider } from '@/utils/post';

export default function AboutPage({ about }) {
  return <SinglePostLayout post={about} />;
}

export async function getStaticProps({ params }) {
  const blogProvider = new PostProvider('about');
  const post = blogProvider.getBySlug('about', ['title', 'image', 'content']);
  const content = await markdownToHtml(post.content || '');

  return {
    props: {
      about: {
        ...post,
        subtitle: 'About',
        content,
      },
    },
  };
}
